import type { MidiTrack, MidiFile } from "../models/midi-file";

export class DetectDrumTracks {
  invoke(midiFile: MidiFile): MidiTrack[] {
    return midiFile.tracks.filter(
      (track) =>
        track.name.toLowerCase().includes("percussion") ||
        track.name.toLowerCase().includes("drum"),
    );
  }
}
